import { render, staticRenderFns } from "./ticket-browser.vue?vue&type=template&id=26480cde&"
import script from "./ticket-browser.vue?vue&type=script&lang=js&"
export * from "./ticket-browser.vue?vue&type=script&lang=js&"
import style0 from "./ticket-browser.vue?vue&type=style&index=0&id=26480cde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TicketListItem: require('/home/code/flirt-admin/components/TicketListItem.vue').default})
